import Vue from 'vue'
import Router, { Route, RawLocation } from 'vue-router'
import routes from './routes'
import Auth from '@aws-amplify/auth'
import _ from 'lodash'
import store from '@/store'

Vue.use(Router);

const router = new Router({
  //mode: 'history',
  routes,
});

router.beforeEach((to: Route, from: Route, next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) => {
  if (to.meta && to.meta.title) {
      document.title = to.meta.title
  }

  if (to.meta && to.meta.auth !== undefined) {
      // heading to a page that needs auth
      if (to.name === 'signIn') {
        Auth.currentAuthenticatedUser().then( res => {
          const hasAccess = _.isString(_.get(res, 'signInUserSession.accessToken.jwtToken')) 
          if (hasAccess) {
            router.push({ name: 'home'})
            return
          }
          //redirect
          next()
          return
        })
        .catch((err: any) => {
          router.push({ name: 'signIn' })
          return
        })
      }

      if (to.meta.auth) {
          //authenticated?
          store.dispatch('GET_BALANCE')
          Auth.currentAuthenticatedUser().then( res => {
            const hasAccess = _.isString(_.get(res, 'signInUserSession.accessToken.jwtToken')) 
            if (hasAccess) {
              next()
              return
            }
            //redirect
            router.push({ name: 'signIn' })
            return
          })
          .catch((err: any) => {
            router.push({ name: 'signOut' })
            return
          })
      }
      next()
      return
  }
  next()
  return

});

export default router;
